import styled from 'styled-components';
import theme from '../../styles/theme';
import footerTopDots from './footer-dot.png';
import MediaBreakDown from '../../styles/MediaBreakDown';


export const Wrapper = styled.footer`
  border-top: 0;

  .dots-divider {
    background-image: url(${footerTopDots});
    background-repeat: repeat;
    height: 80px;
    clear: both;
  }

  .footer-top {
    max-width: 2500px;
    width: 100%;

    img {
      width: 100%;
    }
  }

  ul {
    list-style: none;
    padding: 0px;
    margin: 0px;
  }
  li {
    margin: 0px;
  }
  @media(max-width: 1900px) {
    .footer-top {
      width: 1900px;
    }
  }
  @media(max-width: 1600px) {
    .footer-top {
      max-width: 1600px;
      width: 100%;
    }
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2.438rem 0px;

  @media (min-width: 733px) {
    flex-direction: row;
  }
`;

export const BrandWrapper = styled.div`
  min-width: 7rem;
`;

export const MenusWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;

  ${MediaBreakDown.md`
    margin-left: auto;
  `}
  ${MediaBreakDown.lg`
    margin-right: 0;
  `}
`;

export const Menu = styled.div`
  display: inline-block;
  margin-bottom: 30px;

  h3 {
    margin-bottom: 0.68rem;
    font-size: 1.25rem;
    line-height: 1.5;
  }

  a {
    font-size: 0.875rem;
  }

  li {
    &:not(:last-child) {
      margin-bottom: 0.35rem;
    }
    &.with-image {
      margin-top: 30px;
     
      img {
        width: 120px;
      }
    }
  }
  li.with-image ~ li.with-image {
    margin-top: 0;
  }

  
  ${MediaBreakDown.xl`
    width: 30%;

    &:not(:last-child) {
      margin-right: 12px;
      margin-left: 12px;
    }
  `}
  ${MediaBreakDown.md`
    width: 45%;

    &:not(:last-child) {
      margin-right: 12px;
      margin-left: 0;
    }
  `}
`;

export const LineWrapper = styled.div`
  background-color: ${theme.navbar.dark};
`;

export const Line = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 0.87rem;
  padding: 0.75rem 0px;

  .left-content {
    margin: 0.75rem;
    display: flex;
    color: ${theme.textColor.white90};

    .workast-name {
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      user-select: none;
    }
    .logo-container {
      img {
        margin: 0 14px 0 0;
      }
      .workast-name {
        display: none;
      }
    }
    .text-container {
      display: flex;
      flex-direction: column;
      
      .links-section {
        font-weight: 400;
        font-size: 12px;
        line-height: 12px;
      }
    }
  }
  .right-content {
    li {
      margin: 0 auto;
      min-width: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 20px;
    }
  }

  ul {
    display: flex;
    justify-content: center;
    
    li {
      svg path {
        fill: ${theme.textColor.white90};
      }
    }
  }

  ${MediaBreakDown.md`
    flex-direction: column;

    .left-content {
      flex-direction: column;
      align-items: center;
      margin-bottom: 20px;

      .logo-container {
        margin: 0 0 16px 0;
        padding: 0;
        display: flex;
        align-items: center;

        .workast-name {
          display: initial;
        }
      }
      .text-container {
        max-width: 260px;
        text-align: center;

        .links-section {
          line-height: 24px;
        }
        .workast-name {
          display: none;
        }
      }
    }
  `}
`;
